/* eslint-disable react/display-name */
import React from 'react';
import { Messages } from '../../../../../../gen-src/Localize';
import { TypedColumn, TypedBodyCellProps } from '../../dataGrid/TypedDataGridInterfaces';
import { DataQualityIconHeaderFormatterFactory } from '../../dataGrid/headerFormatters/LabelIconHeaderFormatFactory';
import { SiteUrlsContext } from '../../urls/SiteUrlsContext';
import { IconCellWrapper } from '../Styles';
import { useRenderLabels, UseRenderLabelsParams } from '../hook/useRenderLabels';
import { LabelCellFormatterParams, LabelColumnFormatterParams } from '../shared/LabelCellFormatterParams';

export function createWarningColumnFormatter<T,>({ getPropsFromRowData, overrides }: LabelColumnFormatterParams<T, UseRenderLabelsParams>): TypedColumn<T, ''> {
  return ({
    name: 'label-warning',
    dataKey: '',
    headerText: '',
    resizable: false,
    sortable: false,
    headerTooltip: Messages.ColumnHeaderDataQualityWarning(),
    headerFormatter: DataQualityIconHeaderFormatterFactory,
    cellFormatter: createWarningCellFormatter<T>({ getPropsFromRowData }),
    ...overrides,
  });
}

function createWarningCellFormatter<T>({ getPropsFromRowData }: LabelCellFormatterParams<T, UseRenderLabelsParams>): React.Factory<TypedBodyCellProps<T>> {
  return (cellFormatterProps: TypedBodyCellProps<T>) => {
    const props: UseRenderLabelsParams = getPropsFromRowData(cellFormatterProps.row.data);
    return <WarningCellFormatter {...props} />
  }
}

function WarningCellFormatter(props: UseRenderLabelsParams): JSX.Element {
  const siteUrls = React.useContext(SiteUrlsContext);
  const { warnings } = useRenderLabels({
    controls: { kind: 'icon', siteUrls: (props.controls && 'siteUrls' in props.controls) ? props.controls?.siteUrls : siteUrls },
    ...props
  });
  return (
    <IconCellWrapper>
      {warnings}
    </IconCellWrapper>
  )
}
